<p-dialog
	[visible]="visible"
	(visibleChange)="visibleChange.emit($event)"
	[modal]="true"
	[dismissableMask]="true"
	[closable]="false"
	[breakpoints]="REA_DIALOG_BREAKPOINTS"
	(onShow)="onDialogShow()"
	[style]="{ width: '54vw' }"
	styleClass="rea-dialog"
	id="export-rea-dialog"
>
	<ng-template pTemplate="header">
		<div class="rea-header">
			<div class="rea-header__title">
				<i class="pi pi-download" aria-hidden="true"></i>
				<span>Importar REA</span>
			</div>

			<div class="rea-header__badges">
				@if (historicoREA?.isOk) {
					<p-tag
						[value]="'Última importación: ' + lastReaFecha"
						severity="info"
						[rounded]="true"
						class="rea-badge"
					></p-tag>
				}

				@if (historicoREA?.isCreated) {
					<p-tag value="Nueva importación" severity="success" [rounded]="true" class="rea-badge"></p-tag>
				}
			</div>
		</div>
	</ng-template>

	<div class="rea-body">
		<p-card class="rea-card">
			<app-rea-import-basic-data
				[nif]="model.titular_nif"
				[codigoRea]="importedRea"
			></app-rea-import-basic-data>

			@if (showSpinner) {
				<div class="rea-spinner">
					<div class="rea-spinner__content">
						<p-progress-spinner strokeWidth="6" animationDuration="1.2s"></p-progress-spinner>
						<p>{{ messageState === 'checking' ? 'Comprobando datos REA...' : 'Importando datos oficiales REA...' }}</p>
					</div>
				</div>
			}

			<app-rea-import-main-status
				[viewState]="mainViewState"
				[hasCurrentError]="hasCurrentError"
				[recoveryAction]="recoveryAction"
				[supportEmailHref]="currentErrorSupportEmailHref"
				[technicalDetails]="currentTechnicalDetails"
				[primaryValueMessage]="primaryValueMessage"
			></app-rea-import-main-status>

			@if (!hasCurrentError) {
				@if (showCheckSelection) {
					<app-rea-import-check-selection
						[check]="richCheckResult"
						[hasImportResult]="richImportResult !== null"
						[selectedRea]="selectedRea"
						[availableExplotaciones]="availableExplotaciones"
						[viewState]="checkViewState"
						[invalidSelectedReaMessage]="invalidSelectedReaMessage"
						(selectedReaChange)="setSelectedRea($event)"
					></app-rea-import-check-selection>
				}

				<app-rea-import-result-summary
					[result]="richImportResult"
					[customerSummaryMetrics]="customerSummaryMetrics"
				></app-rea-import-result-summary>

				<app-rea-import-user-warnings [warnings]="userWarnings"></app-rea-import-user-warnings>

				<app-rea-import-optional-review
					[hasMapInsights]="hasMapInsights"
					[suggestedMapLayers]="suggestedMapLayers"
					[changesTruncated]="richImportResult?.changesTruncated === true"
					[recentChanges]="recentChanges"
					[changeDigestMetrics]="changeDigestMetrics"
					[reviewReasons]="reviewReasons"
					[reviewRequiredCount]="reviewRequiredCount"
					(reviewRequested)="requestParcelReview($event)"
				></app-rea-import-optional-review>

				@if (showAuditHistorySection) {
					<app-rea-import-history
						[showPanel]="showAuditHistoryPanel"
						[records]="auditRecords"
						[selectedAuditImportId]="selectedAuditImportId"
						[auditDetailLoading]="auditDetailLoading"
						[selectedAuditDetail]="selectedAuditDetail"
						[selectedAuditChanges]="selectedAuditChanges"
						(togglePanel)="toggleAuditHistory()"
						(selectRecord)="showAuditDetail($event)"
						(closeDetail)="closeAuditDetail()"
					></app-rea-import-history>
				}
			}
		</p-card>
	</div>

	<ng-template pTemplate="footer">
		<div class="rea-footer">
			<p-button
				[label]="closeButtonLabel"
				severity="secondary"
				[fluid]="true"
				(onClick)="hide()"
			>
			</p-button>

			@if (canOpenImportedFinca) {
				<p-button
					type="button"
					label="Ver explotación importada"
					icon="pi pi-external-link"
					severity="success"
					[fluid]="true"
					(onClick)="openImportedFinca()"
				>
				</p-button>
			}

			@if (canSend) {
				<p-button
					type="button"
					label="Importar datos REA"
					[loading]="showSpinner && messageState !== 'checking'"
					[disabled]="!canImport"
					severity="success"
					[fluid]="true"
					(onClick)="exportREA()"
				>
				</p-button>
			}
		</div>
	</ng-template>
</p-dialog>
